<template>
  <b-form-group class="accordion" role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" role="tab">
        <div style="cursor: pointer" @click="visible = !visible">PATHOGEN</div>
      </b-card-header>
      <b-collapse v-model="visible" role="tabpanel">
        <b-card-body>
          <VForm ref="observer" v-slot="{ meta: formMeta }" as="div">
            <b-form @submit.prevent="savePathology">
              <p>Optional</p>
              <b-input-group>
                <label>Pathogen</label>
                <b-form-input
                  id="pathogen"
                  ref="micPath"
                  v-model="form.pathogen"
                  placeholder="Enter pathogen"
                  @input="savePathology"
                ></b-form-input>
              </b-input-group>
              <b-input-group>
                <label>MIC</label>
                <VField v-slot="{ meta }" v-model="form.mic" name="mic" :rules="rules">
                  <b-form-input
                    id="mic"
                    v-model="form.mic"
                    name="mic"
                    type="number"
                    :number="true"
                    class="input-with-unit"
                    placeholder="Enter MIC"
                    :state="getValidationState(meta)"
                    required
                    @input="savePathology"
                  />
                </VField>
                <b-form-select
                  id="micUnit"
                  ref="micUnit"
                  v-model="form.micUnit"
                  :options="micUnits"
                  value-field="value"
                  text-field="text"
                  class="unit-dropdown"
                  :clearable="false"
                  required
                  @change="savePathology"
                >
                </b-form-select>
              </b-input-group>
              <VErrorMessage name="mic" as="div" class="invalid-feedback d-block" />
            </b-form>
          </VForm>
        </b-card-body>
      </b-collapse>
    </b-card>
  </b-form-group>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { displaySIUnits, units } from '@/models/utils/constants.js';
import { pathogens } from '@/models/utils/pathogens.js';
import { useDosingStore } from '@/stores/dosing';

defineOptions({ name: 'PathologyInput' });

const props = defineProps<{ drug: any; pathologyData: any }>();

const store = useDosingStore();
const visible = ref(false);
const observer = ref<any>(null);

const micUnits = units.micConcentration.map((u: string) => ({ value: u, text: displaySIUnits(u) }));
const rules = { required: true, micBetween: true };

function initForm() {
  const pathology = props.pathologyData ?? null;
  return {
    pathogen: pathology ? pathology.pathogen : (null as string | null),
    mic: pathology ? pathology.mic : (null as number | null),
    micUnit: pathology ? pathology.micUnit : 'mg/L',
  };
}

const form = ref(initForm());

watch(
  () => props.pathologyData,
  () => {
    form.value = initForm();
  },
);

function getValidationState(meta: { validated: boolean; valid: boolean }): boolean | null {
  return meta.validated ? meta.valid : null;
}

function savePathology($event: any) {
  observer.value.validate().then(({ valid }: { valid: boolean }) => {
    if (valid) {
      if (props.drug && pathogens[$event]) {
        const p = props.drug.pathology.filter((t: any) => t.pathogen === form.value.pathogen)[0];
        form.value.mic = p ? p.mic : pathogens[form.value.pathogen!]?.[props.drug.id];
        form.value.micUnit = p ? p.micUnit : 'mg/L';
      }
      store.savePathology(form.value);
    }
  });
}
</script>

<style scoped></style>
